import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setAllAttendeesPage = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<number>((state, action) => {
    state.allAttendees.page = action.payload;
  });
